import { gql } from '@apollo/client';

export const SetCurrentRegionalCenterMutation = gql`
    mutation setCurrentRegionalCenter($id: ID!) {
        setCurrentRegionalCenter(id: $id)
    }
`;
